import type { JSTLandingScreen } from './JSTLandingScreen';

import TypedNativeModules from '../internal/TypedNativeModules';

export default async function navigateTo(
    landingScreen: JSTLandingScreen,
    from: string | null,
): Promise<void> {
    await TypedNativeModules.RNJSTNavigator?.navigateTo?.(landingScreen, from);
}
